<div class="video-modal">
  <div class="modal-header">
    <mat-icon class="header-icon">play_circle</mat-icon>
    <h3 class="modal-title">{{ data.video.title }}</h3>
  </div>

  <div class="modal-body">
    <app-signature-video-player
      #player
      [config]="playerConfig"
      [startTime]="startTime"
      (videoCompleted)="onVideoCompleted()"
      (videoStarted)="onVideoStarted()"
      (videoPaused)="onVideoPaused()"
      (videoResumed)="onVideoResumed()"
    ></app-signature-video-player>

    <p class="modal-hint">
      {{ 'WatchFullVideoToContinue' | translate }}
    </p>
  </div>
</div>
